/* eslint-disable indent */
export function toggleTabs() {
    let $tabsLink = $(".tabs-box .tabs-nav a");
    let $header = $(".header");
    $tabsLink.on("click", function (e) {
        e.preventDefault();
        let $this = $(this);
        let $parent = $this.parents(".tabs-box");
        let $tabContent = $parent.find(".tab-content-info");
        let $parentNav = $this.parents(".tabs-nav");
        let $parentItem = $parentNav.find("li");
        let target = $this.attr("href");
        $parentItem.removeClass("active");
        $this.parent().addClass("active");
        $tabContent.removeClass("active");
        $(target).addClass("active");

        if (window.innerWidth < 768) {
            let $parentTop = $parent.offset().top;
            let $parentNavHeight = $parentNav.height();
            $("body,html")
                .stop()
                .animate(
                    {scrollTop: $parentTop + $parentNavHeight - $header.innerHeight()},
                    500
                );
        }
    });
    $(".tabs-box").each(function () {
        $(this).find(".tabs-nav li:first-child").addClass("active");
        $(this).find(".tabs-content .tab-content-info:first-child").addClass("active");
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/tabs.js